import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-search",
  "use": "foquz-icon-search-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol viewBox=\"0 0 18 17\" fill=\"none\" id=\"foquz-icon-search\"><path d=\"M12.494 12.077l3.61 3.61m-3.02-8.645A6.042 6.042 0 111 7.042a6.042 6.042 0 0112.084 0z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol